import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../service/auth.service';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { User } from '../../class/user';
import { Observable } from 'rxjs/Observable';
import * as firebase from'firebase/app';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  login: boolean;
  username: string;
  disp: string;
  users: Observable<User[]>;
  usersRef: AngularFireList<any>;
  key:string;

  constructor(
    private afAuth: AngularFireAuth,
    private authService: AuthService,
    private db: AngularFireDatabase) { 
      this.afAuth.authState.subscribe(user => {
        if (user) {
          this.login = true;
          this.username = user.displayName;
          this.disp = this.username;
        } else {
          this.login = false;
        }
      });
     }

ngOnInit() { }

logout(): void {
  this.authService.logout();
}

mouseover(): void {
  this.disp = "logout";
}

mouseout(): void {
  this.disp = this.username;
}

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/core/header/header.component.ts